import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  type SetStoreDefaultReleasesPayload,
  setStoreDefaultReleases,
} from 'api/admin/stores/setStoreDefaultReleases';

export const useSetStoreDefaultReleases = ({
  successCallback,
}: {
  successCallback?: () => void;
}) => {
  return useMutation<unknown, AxiosError<{ error: string }>, SetStoreDefaultReleasesPayload>({
    mutationFn: async ({ storeId, defaultReleases }: SetStoreDefaultReleasesPayload) => {
      return setStoreDefaultReleases({ storeId, defaultReleases });
    },
    onSuccess: async () => {
      successCallback?.();

      toaster('Default releases updated successfully', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);

      toaster(error?.response?.data?.error ?? 'Failed to update default releases', {
        icon: '❌',
      });
    },
  });
};
